import { discrepancyColumns } from '../config/discrepancy-columns';
import Table from '@/components/table/Table';
import { useState } from 'react';

const ROWS_PER_PAGE = 5;

interface DiscrepancyTableProps {
  data: { number: number }[];
  title: string;
  description: string;
  titleColorClass: string;
  emptyMessage: string;
}

const DiscrepancyTable = ({
  data,
  title,
  description,
  titleColorClass,
  emptyMessage,
}: DiscrepancyTableProps) => {
  const [currentPage, setCurrentPage] = useState(1);

  const paginatedData = data.slice(
    (currentPage - 1) * ROWS_PER_PAGE,
    currentPage * ROWS_PER_PAGE
  );

  return (
    <div className='bg-white rounded-xl shadow-sm p-6'>
      <div className='flex flex-col gap-1.5 mb-6 border-b border-gray-100 pb-4'>
        <h2
          className={`text-xl font-bold uppercase tracking-wider ${titleColorClass}`}
        >
          {title}
        </h2>
        <p className='text-sm text-gray-600 leading-relaxed'>{description}</p>
      </div>
      {data.length > 0 ? (
        <div className='overflow-hidden border border-gray-100 rounded-lg bg-white shadow-inner-sm'>
          <Table
            columns={discrepancyColumns}
            data={paginatedData}
            pagination={{
              totalItems: data.length,
              totalPages: Math.ceil(data.length / ROWS_PER_PAGE),
              currentPage,
              rowsPerPage: ROWS_PER_PAGE,
              onPageChange: setCurrentPage,
              onRowsPerPageChange: () => {},
              rowsPerPageOptions: [ROWS_PER_PAGE],
            }}
          />
        </div>
      ) : (
        <div className='text-center py-8 border border-dashed border-gray-200 rounded-lg text-gray-400 text-sm font-semibold bg-gray-50/50'>
          {emptyMessage}
        </div>
      )}
    </div>
  );
};

export default DiscrepancyTable;
